var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogin = function SvgLogin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 36 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-734 -11)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(734 11)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m759.7 36.254-4.917-2.847a1 1 0 0 1-.1-1.675 4.554 4.554 0 0 0 1.676-2.395h0s.073-.262.173-.633a1.008 1.008 0 0 0 1.16-.54h0a8.988 8.988 0 0 0 .369-1.26 9.216 9.216 0 0 0 .153-1.024V25.852a1.388 1.388 0 0 0 0-.151v-.04h0a1.009 1.009 0 0 0-.892-.895h-.022c.1-.8.2-1.565.219-1.75a4.724 4.724 0 0 0 .029-.5 4.543 4.543 0 0 0-2.694-4.149 7.564 7.564 0 0 0-5.725 0 4.521 4.521 0 0 0-2.665 4.649c.022.184.117.953.218 1.75h-.021a1.009 1.009 0 0 0-.893.895h0v.219a8.6 8.6 0 0 0 .522 2.284h0a1.009 1.009 0 0 0 1.16.54c.1.371.173.633.173.633h0a4.554 4.554 0 0 0 1.676 2.395 1 1 0 0 1-.1 1.675l-4.917 2.847a3.842 3.842 0 0 0-1.91 3.178h19.223a3.843 3.843 0 0 0-1.895-3.178Z"
  }))));
};
export default SvgLogin;